import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { EmployeeListContext } from '../EmployeeList.context';
import classes from '../EmployeeList.module.css';
export const EmptySearchMessage = () => {
    const { state } = useContext(EmployeeListContext);
    return (_jsxs("div", { className: classes.emptyWrapper, children: ["\u041C\u044B \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0448\u043B\u0438 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u00AB", state.searchQuery, "\u00BB.", _jsx("br", {}), "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u043E\u0441"] }));
};
